import { registerUser } from '../api/authapi';
import fetchApi from '../api/fetch';
import 'material-icons'
import React, { useState,useEffect,useRef } from 'react'
import headerpic from './../assets/images/repaire.PNG'
import omid from './../assets/images/omid.jpg'
import aboozar from './../assets/images/aboozar.jpg'
import bios from './../assets/images/bios2.png'
import schematic from './../assets/images/schematic.png'
import boardview from './../assets/images/boardview.png'
import modem from './../assets/images/modem.png'
import vga from './../assets/images/vga2.png'
import monitor from './../assets/images/monitor.png'
import meregion from './../assets/images/meregion.png'
import './../component/style.css'
import logo from './../assets/images/logo.PNG'
import loginImg from './../assets/images/login.png'
import register from "./../assets/images/register.png"
import request from "./../assets/images/requestfile.jpg"
import { loginUser } from './../api/authapi';
import { useAuth } from './../context/AuthContext';
import { getProductTypes, getBrands, getFiles, downloadFile } from './../api/productApi';
import { getSubscriptionStatus } from './../api/subscriptionApi';
import { getPublicPlans } from './../api/plansApi';
import { purchaseSingleFile } from './../api/productApi';
import { getDailyDownloadLimit } from '../api/settingsApi';
import { BASE_URL } from './../config';
export const Header=()=>{
    return(
        <div className='w3-row'>
            <div className=' w3-hide-small w3-half ' >
                <img src={headerpic} alt='headerpic' className='w3-circle w3-ripple' style={{paddingLeft:"200px",marginTop:"10px"}}/>
            </div>
            <div className='w3-hide-large w3-hide-medium'>
                <img src={headerpic} alt='headerpic' className='w3-circle w3-ripple' style={{marginRight:"8%",width:"85%",height:"85%"}}/>
            </div>
            <div className='w3-hide-small  w3-padding w3-half' style={{height:"575px",display:"flex",justifyContent:"center",alignItems:"flex-start",textAlign:"center"}}>
                <h1 className='w3-text-green' style={{fontSize:"40px",fontWeight:"boler"}}>با دانلود بایوس قدرت در دستان شماست !!!</h1>
                <h3 className='w3-text-white'><span className='material-icons w3-text-yellow '>done_outline</span>مرجع مطمئن فایل های بایوس/شماتیک / بوردویوو لپ تاپ     </h3>
                <h3 className='w3-text-white'><span className='material-icons w3-text-yellow '>done_outline</span>مرجع دانلود فایل های بایوس کارت گرافیک و مودم ومانیتور     </h3>
                <h3 className='w3-text-white'><span className='material-icons w3-text-yellow '>done_outline</span>پشتیبانی 24 ساعته</h3>
            </div>
             <div className='w3-hide-large w3-hide-mediume  w3-padding' style={{width:"100%",display:"flex",justifyContent:"center",alignItems:"flex-start",textAlign:"center"}}>
                <h1 className='w3-text-green' style={{fontSize:"40px",fontWeight:"boler"}}>با دانلود بایوس قدرت در دستان شماست !!!</h1>
                <h3 className='w3-text-white'><span className='material-icons w3-text-yellow '>done_outline</span>مرجع مطمئن فایل های بایوس/شماتیک / بوردویوو لپ تاپ     </h3>
                <h3 className='w3-text-white'><span className='material-icons w3-text-yellow '>done_outline</span>مرجع دانلود فایل های بایوس کارت گرافیک و مودم ومانیتور     </h3>
                <h3 className='w3-text-white'><span className='material-icons w3-text-yellow '>done_outline</span>پشتیبانی 24 ساعته</h3>
            </div>
        </div>
    )
}
export const Team=()=>{
    return(
        <div className=" w3-container  w3-padding-64" id='teamid' style={{backgroundColor:"#263238"}}>
  <p className="w3-center w3-xxlarge " style={{fontWeight:'bolder',color:"#ffff"}}>{"تیم کاری ما"}</p>
    <div className="w3-row-padding w3-center w3-content">
            <div className="w3-half w3-margin-bottom">
                <div className="w3-card w3-white w3-round-xxlarge">
                    <img src={omid} alt='omid farahmand' className='w3-round-xxlarge w3-border w3-border-blue' style={{width:'70%',marginTop:'20px'}}/>
                    <div className="w3-container ">
                        <p style={{color:"#000000"}}>{"امید رضا فرهمند"}</p>
                        <p style={{color:"#000000"}}>{ "مدیر پشتیبانی"}</p>
                    </div>
                </div>
            </div>
            <div className="w3-half w3-margin-bottom ">
                <div className="w3-card w3-white w3-round-xxlarge">
                    <img src={aboozar} alt='aboozar zarei' className='w3-round-xxlarge w3-border w3-border-blue' style={{width:'70%',marginTop:'20px'}}/>
                    <div className="w3-container ">
                        <p style={{color:"#000000"}}>{"ابوذر زارعی"}</p>
                        <p style={{color:"#000000"}}>{"مدیر فنی"}</p>
                    </div>
                </div>
            </div>
    </div>
</div>

    )
}
export const Aboutbutton=(props)=>{
const {lable1,lable2,lable3,lable4,pic}=props
  return(
    <div>
          <div className="w3-third w3-border w3-card w3-border-white w3-round-xxlarge">
              <i className="w3-margin-bottom w3-jumbo w3-center"></i>
              <p className="w3-large w3-wide" style={{direction : "rtl",color:"#fff"}}>{lable1}</p>
              <img className="w3-border w3-round-xxlarge w3-border-white w3-circle" src={pic} alt='pic'/>
              <p style={{direction : "rtl",color:"#ffff"}}>{lable2} <i className='w3-text-white w3-padding w3-round-xxlarge' style={{marginRight:'3px',backgroundColor:'red' ,fontWeight:'bold',direction : "rtl"}}>{lable3}</i> {lable4}</p>
          </div>

    </div>
  )
}
export const About = (props)=>{

const arrabout=[
  {
    id:"1",
    lable1:"بایوس لپ تاپ",
    lable2:"ارائه دهنده فایل",
    lable3:"بایوس",
    lable4:"تمام برند های لپ تاپ",
    pic:bios
  },
  {
    id:"2",
    lable1:"شماتیک لپ تاپ",
    lable2:"ارائه دهنده فایل",
    lable3:"شماتیک",
    lable4:"تمام برند های لپ تاپ",
    pic:schematic
    },
    {
      id:"3",
      lable1:"بوردویوو لپ تاپ",
      lable2:"ارائه دهنده فایل",
      lable3:"بوردویوو",
    lable4:"تمام برند های لپ تاپ",
    pic:boardview
  },
  {
    id:"4",
    lable1:"رام مودم",
    lable2:"ارائه دهنده فایل",
    lable3:"مودم",
    lable4:"تمام برند های لپ تاپ",
    pic:modem

  },
  {
    id:"5",
    lable1:"رام مانیتور",
    lable2:"ارائه دهنده فایل",
    lable3:"مانیتور",
    lable4:"تمام برند های لپ تاپ",
    pic:monitor
  },
  {
    id:"6",
    lable1:"کارت گرافیک",
    lable2:"ارائه دهنده فایل",
    lable3:"کارت گرافیک",
    lable4:"تمام برند های لپ تاپ",
    pic:vga
  },
  
]
return(
<div className="w3-container" style={{backgroundColor:"#263238",padding:"12px 16px"}} >
  <h3 className="w3-center w3-xxlarge" style={{fontWeight:'bolder',direction :"rtl",color:"#ffff"}}>{"درباره ما"}</h3>
  <p className="w3-center w3-xlarge" style={{direction : "rtl",color:"#ffff"}}>{ "ویژگی های سایت ما"}</p>



  <div className=" w3-center " style={{margintop:"64px"}}>
    {arrabout.map(button=><Aboutbutton key={button.id}{...button}/>)}
  </div>
  
        <div className="w3-padding-64 w3-card w3-border-white w3-center  ">
            <i className="w3-margin-bottom w3-jumbo w3-center" ></i>
            <p className="w3-large w3-wide" style={{marginTop:'730px',marginBottom:'40px',color:"#ffff"}}>MeRegion </p>
            <img alt='meregion' className="w3-border w3-round-xxlarge w3-border-white w3-circle" src={meregion}/>
            <p style={{direction : "rtl",color:"#fff"}}>{"ارائه دهنده فایل"} <i className='w3-text-white w3-padding w3-round-xxlarge' style={{marginRight:'3px',backgroundColor:'red' ,fontWeight:'bold',direction :"rtl"}}>{"MEREGION"}</i> {"تمام برند های لپ تاپ "}</p>
          </div>
</div>
)
}
export const Skillbutton1=(props)=>{
  const {lable}=props
  return(
    <div>
      <p className='w3-text-white' style={{direction:"rtl"}}><span className="material-icons w3-text-green" style={{fontWeight:'bolder'}}>keyboard_double_arrow_right</span> {lable}</p>
    </div>
  )
}
export const Skillbutton2=(props)=>{
  const {lable,icon,num,progress}=props
  return(
    <div>
                     <p className=" w3-text-white w3-wide" style={{direction : "rtl"}}><span className="w3-text-white material-icons w3-text-green w3-margin-right" style={{fontWeight:'bold',direction : "rtl"}}>{icon}</span>{lable}</p>
                    <div className="w3-round-xlarge w3-border w3-border-blue" style={{backgroundColor:'#4FC3F7',direction :"rtl"}}>
                        <div className="w3-container w3-center w3-round-xlarge w3-text-white" style={{width:progress,backgroundColor:'#0277BD',lineHeight:'20px',fontSize:'12px',fontWeight:'bold'}}>{num}</div>
                    </div>
     

    </div>
  )
}
export const Skill = (props)=>{
const arrskill1=[
  {
    id:"1",
    lable:"امروزه با توجه به اهمیت تعمیرات قطعات الکترونیکی و لپ تاپ در دنیا سعی ما بر این بوده تا بتوانیم با ارائه خدماتی در این زمینه همراه شما عزیزان باشیم."
  },
    {
    id:"2",
    lable:"تمام تلاش ما بر این بوده تا بتوانیم آرشیو بزرگی از فایل های بایوس/ شماتیک / بردویو انواع برند های لب تاپ و ویدیوهای آموزش تعمیرات لپ تاپ و همچنین فایل های ROM گرافیک و مانیتور را در دسترس شما عزیزان قرار دهیم."
  },
    {
    id:"3",
    lable:"اینجا میتوانید با داشتن یک عضویت ویژه از کلیه خدمات استفاده کرده و همچنین با دانلود وآپلود فایل و ثبت نظرات و فید بک های سازنده کمک کنید تا دانلود بایوس کامل و کاملتر شود."
  },
    {
    id:"4",
    lable:"در صورتیکه هرگونه سوالی در زمینه خدمات دانلود بایوس داشتید میتوانید از طریق صفحه ارتباط با ما اقدام نمایید."
  },
]  

const arrskill2=[
  {
    id:"1",
    lable:"رام گرافیک",
    icon:"file_download",
    num:"11998",
    progress:"90%"
  },
    {
    id:"2",
    lable:"بایوس لپ تاپ",
    icon:"file_download",
    num:"6671",
    progress:"70%"
  },
    {
    id:"3",
    lable:"شماتیک لپ تاپ",
    icon:"file_download",
    num:"1503",
    progress:"60%"
  },
    {
    id:"4",
    lable:"بورد ویوو لپ تاپ",
    icon:"file_download",
    num:"1425",
    progress:"50%"
  },
  {
    id:"5",
    lable:"MERegion LapTop",
    icon:"file_download",
    num:"992",
    progress:"40%"
  },
  {
    id:"6",
    lable:"رام مانیتور",
    icon:"file_download",
    num:"929",
    progress:"70%"
  },{
    id:"7",
    lable:"بایوس مودم",
    icon:"file_download",
    num:"500",
    progress:"60%"
  },
]  
return(
<div className="w3-container w3-padding-64" style={{backgroundColor:"#263238"}}>
  <div className="w3-row-padding ">
    <div className="w3-col m6 ">
      <p className='w3-xxlarge w3-text-white' style={{fontWeight:'bolder',fontSize:'34px',direction :  "rtl"}}>{"فایل های بارگذاری شده در سایت"}</p>
      {arrskill1.map(button=> <Skillbutton1 key={button.id}{...button} />)}
    </div>
    <div className="w3-col m6">
      {arrskill2.map(button=> <Skillbutton2 key={button.id}{...button} />)}
    </div>
  </div>
</div>
)
}
export const Contact = (props)=>{
return(
    <div className="w3-container w3-padding-64" style={{backgroundColor:"#263238"}} id='contactid'>
    <h3 className=" w3-border-light-grey w3-padding-16 w3-center w3-xxlarge" style={{fontWeight:'bolder',marginBottom:'0',color:"#fff"}}>{"تماس با ما"} </h3>
    <p className='w3-center' style={{fontSize:'22px',marginTop:'0',color:"#fff"}}>{ "لطفا نظرات و پیشنهادات خود را با ما در میان بگذارید"}</p>
    <p style={{direction : "rtl",color:"#fff"}}>{"آدرس : ایران -استان فارس -لارستان شهرجدید 20 متری وحدت انتهای فاز 4 بازار امام خمینی"}</p>
    <p style={{direction : "rtl",color:"#fff"}}> <a href="tel:09372206704" style={{textDecoration:'none'}}>{ "شماره تماس : فرهمند -  09372206704"}</a> -- <a href="tel:09177817327" style={{textDecoration:'none'}}>9177817327 - زارعی</a></p>
    <p style={{direction : "rtl",color:"#fff"}}> <a href="mailto:downloadbios.net@gmail.com?subject=subject&body=body%27);" style={{textDecoration:'none'}}>Email : downloadbios.ir@gmail.com</a></p>
    <p style={{direction : "rtl",color:"#fff"}}><a href='https://wa.me/989177817327?text=' style={{textDecoration:'none'}}>WhatsApp : 09177817327</a> -- <a href='https://wa.me/989372206704?text=' style={{textDecoration:'none'}}>09372206704</a></p>
    {/* <h5><a href='https://wa.me/989372206704?text='><span className="material-icons">whatsapp</span>WhatsApp : 09372206704</a></h5> */}
    <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=768745&Code=Yu65q0n9mnnaK8oauBSzjtwXk9IvNUZk'>
    <img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=768745&Code=Yu65q0n9mnnaK8oauBSzjtwXk9IvNUZk' alt='' style={{cursor:'pointer', code:'Yu65q0n9mnnaK8oauBSzjtwXk9IvNUZk'}} />
    </a>
</div>
)
}
function formatPrice(price) {
  return new Intl.NumberFormat('fa-IR').format(price);
}

export const Pricing = () => {
  const { isAuthenticated, token } = useAuth();
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  const [modal, setModal] = useState({ show: false, type: 'error', message: '' });

  const features = [
    'پشتیبانی 24 ساعته',
    'دانلود بایوس،شماتیک و بوردویوو لپ تاپ',
    'دانلود فایل بایوس مودم',
    'دانلود فایل رام مانیتور',
    'دانلود فایل رام گرافیک',
    'Meregion  لپ تاپ'
  ];

  useEffect(() => {
    async function loadPlans() {
      setLoadingPlans(true);
      const result = await getPublicPlans();
      setLoadingPlans(false);

      if (result.success) {
        setPlans(result.data.plans);
      } else {
        setModal({ show: true, type: 'error', message: 'خطا در دریافت لیست پلن‌ها.' });
      }
    }
    loadPlans();
  }, []);

  const handlePurchase = async (planId) => {
    if (!isAuthenticated) {
      setModal({
        show: true,
        type: 'error',
        message: 'برای خرید پلن، ابتدا باید وارد حساب کاربری خود شوید.'
      });
      return;
    }

    setLoadingPlanId(planId);

    try {
      const response = await fetch(`${BASE_URL}/payment/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ planId })
      });

      const data = await response.json();

      if (response.ok && data.paymentUrl) {
        window.location.href = data.paymentUrl;
      } else {
        setModal({ show: true, type: 'error', message: data.message || 'خطا در اتصال به درگاه.' });
        setLoadingPlanId(null);
      }
    } catch (error) {
      setModal({ show: true, type: 'error', message: 'خطا در ارتباط با سرور.' });
      setLoadingPlanId(null);
    }
  };

  const closeModal = () => setModal({ show: false, type: 'error', message: '' });

  return (
    <div className="w3-container w3-center w3-padding-64" id="pricingid" style={{ padding: '18px 16px' }}>
      <p style={{ fontWeight: 'bolder', fontSize: '34px' }} className="w3-text-white">
        عضویت ویژه
      </p>
      <p style={{ fontWeight: 'bolder', fontSize: '18px' }} className="w3-text-white">
        یک طرح متناسب با نیاز خود انتخاب کنید
      </p>

      {loadingPlans ? (
        <p className="w3-text-white" style={{ marginTop: 40 }}>در حال بارگذاری پلن‌ها...</p>
      ) : plans.length === 0 ? (
        <p className="w3-text-white" style={{ marginTop: 40 }}>در حال حاضر پلنی برای نمایش وجود ندارد.</p>
      ) : (
        <div className="w3-row-padding" style={{ marginTop: '84px' }}>
          {plans.map((plan) => (
            <div key={plan.id} className="w3-quarter w3-margin-bottom">
              <ul className="w3-ul w3-hover-shadow w3-round-xxlarge" style={{ backgroundColor: '#ffffff' }}>
                <li className="w3-xlarge w3-padding-48" style={{ color: '#4FC3F7' }}>
                  {plan.title}
                </li>

                {features.map((feature, index) => (
                  <li key={index} className="w3-padding-16">
                    {feature}
                  </li>
                ))}

                <li className="w3-padding-16">
                  <h2 className="w3-wide">
                    <b>
                      <span className="material-icons w3-text-red">payments</span>
                    </b>{' '}
                    {formatPrice(plan.price)} T
                  </h2>
                </li>

                <li className="w3-padding-24" style={{ backgroundColor: '#ffffff' }}>
                  <button
                    onClick={() => handlePurchase(plan.id)}
                    disabled={loadingPlanId === plan.id}
                    className="w3-button w3-black w3-padding-large w3-text-white w3-round-xxlarge"
                  >
                    {loadingPlanId === plan.id ? 'در حال پردازش...' : 'پرداخت'}
                  </button>
                </li>
              </ul>
            </div>
          ))}
        </div>
      )}

      {modal.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{
              backgroundColor: '#263238',
              borderTopLeftRadius: '20px',
              borderBottomRightRadius: '20px',
              maxWidth: '320px',
              width: '90%',
              direction: 'rtl',
              overflow: 'hidden'
            }}
          >
            <div
              className="w3-container w3-padding"
              style={{
                backgroundColor: modal.type === 'success' ? '#15ff0022' : '#ff000022',
                borderBottom: `2px solid ${modal.type === 'success' ? '#15ff00' : '#ff0000'}`
              }}
            >
              <span onClick={closeModal} className="w3-button w3-display-topright" style={{ color: 'white' }}>
                &times;
              </span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>
                {modal.type === 'success' ? '✅ موفقیت' : '❌ خطا'}
              </h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">{modal.message}</p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
              <button
                onClick={closeModal}
                className="w3-button w3-block"
                style={{
                  color: modal.type === 'success' ? '#15ff00' : '#ff0000',
                  backgroundColor: 'transparent',
                  border: `2px solid ${modal.type === 'success' ? '#15ff00' : '#ff0000'}`,
                  borderRadius: '10px'
                }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const inputStyle = {
  border: '1px solid white',
  backgroundColor: 'transparent',
  borderRadius: '2px',
  borderTopLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  fontSize: '16px',
  height: '40px',
  width: '100%',
  color: 'white'
};

export const Request = (props) => {
  const { visible, onHide } = props;

  const [productTypes, setProductTypes] = useState([]);
  const [formData, setFormData] = useState({
    productTypeId: '',
    description: '',
    email: '',
    phone: ''
  });
  const [loading, setLoading] = useState(false);

  const [modal, setModal] = useState({ show: false, type: 'success', message: '' });

  useEffect(() => {
    if (!visible) return;
    async function loadTypes() {
      const result = await getProductTypes();
      if (result.success) {
        setProductTypes(result.data.productTypes);
      }
    }
    loadTypes();
  }, [visible]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const closeMessageModal = () => {
    const wasSuccess = modal.type === 'success';
    setModal({ show: false, type: 'success', message: '' });
    if (wasSuccess) {
      setFormData({ productTypeId: '', description: '', email: '', phone: '' });
      onHide();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.description.trim() || !formData.email.trim() || !formData.phone.trim()) {
      setModal({ show: true, type: 'error', message: 'لطفا مشخصات فایل، ایمیل و شماره تماس را وارد نمایید.' });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/requests`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(formData)
});

      const data = await response.json();

      if (response.ok) {
        setModal({ show: true, type: 'success', message: data.message });
      } else {
        setModal({ show: true, type: 'error', message: data.message });
      }
    } catch (error) {
      setModal({ show: true, type: 'error', message: 'خطا در ارتباط با سرور.' });
    }

    setLoading(false);
  };

  return visible ? (
    <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div
        className="w3-col l3 m8 s11 w3-border w3-border-white w3-card-4 w3-animate-zoom"
        style={{ overflow: 'visible', backgroundColor: '#263238', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}
      >
        <div className="w3-container" style={{ direction: 'rtl', overflow: 'visible' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', overflow: 'visible' }}>
            <img className="w3-circle" src={request} alt="request" style={{ marginTop: -60, zIndex: 5, width: 120 }} />
          </div>

          <form onSubmit={handleSubmit}>
            <div className="w3-text-white w3-section">
              <label><b>نوع فایل</b></label>
              <select
                name="productTypeId"
                value={formData.productTypeId}
                onChange={handleChange}
                className="w3-input"
                style={{ ...inputStyle, color: formData.productTypeId ? 'white' : '#717272' }}
              >
                <option value="" style={{ color: '#383f42' }}>لطفا نوع فایل را انتخاب کنید</option>
                {productTypes.map((type) => (
                  <option key={type.id} value={type.id} style={{ color: '#263238' }}>
                    {type.name}
                  </option>
                ))}
              </select>

              <div style={{ marginTop: 10 }}>
                <label><b>مشخصات کامل فایل</b></label>
                <input
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="لطفا مدل مادربورد / مودم / گرافیک و ... را وارد نمایید"
                  className="w3-input"
                  style={{ ...inputStyle, marginTop: 4 }}
                  required
                />
              </div>

              <div style={{ marginTop: 10 }}>
                <label><b>ایمیل</b></label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="لطفا ایمیل خود را وارد نمایید"
                  className="w3-input"
                  style={{ ...inputStyle, marginTop: 4 }}
                  required
                />
              </div>

              <div style={{ marginTop: 10 }}>
                <label><b>شماره تماس</b></label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="لطفا شماره تماس خود را وارد نمایید"
                  className="w3-input"
                  style={{ ...inputStyle, marginTop: 4 }}
                  required
                />
              </div>

              <div className="w3-bar w3-margin-top">
                <button
                  type="submit"
                  disabled={loading}
                  className="w3-bar-item w3-right w3-button w3-block w3-section w3-padding-small w3-margin-left"
                  style={{ fontSize: 14, color: '#15ff00', backgroundColor: 'transparent', borderRadius: '10px', border: '2px solid #2980b9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  <span className="material-icons w3-text-green w3-padding">send</span>
                  {loading ? 'در حال ارسال...' : 'ارسال درخواست'}
                </button>
                <button
                  type="button"
                  onClick={onHide}
                  className="w3-bar-item w3-left w3-button w3-block w3-section w3-padding-small"
                  style={{ fontSize: 16, color: '#ff0000', backgroundColor: 'transparent', borderRadius: '10px', border: '2px solid #2980b9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  <span className="material-icons w3-padding" style={{ color: '#ff0000' }}>transit_enterexit</span>
                  خروج
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {modal.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{ backgroundColor: '#263238', borderTopLeftRadius: '20px', borderBottomRightRadius: '20px', maxWidth: '320px', width: '90%', direction: 'rtl', overflow: 'hidden' }}
          >
            <div
              className="w3-container w3-padding"
              style={{
                backgroundColor: modal.type === 'success' ? '#15ff0022' : '#ff000022',
                borderBottom: `2px solid ${modal.type === 'success' ? '#15ff00' : '#ff0000'}`
              }}
            >
              <span onClick={closeMessageModal} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{modal.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{modal.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
              <button
                onClick={closeMessageModal}
                className="w3-button w3-block"
                style={{ color: modal.type === 'success' ? '#15ff00' : '#ff0000', backgroundColor: 'transparent', border: `2px solid ${modal.type === 'success' ? '#15ff00' : '#ff0000'}`, borderRadius: '10px' }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : null;
};

const WARNING_THRESHOLD_DAYS = 7; // اگه کمتر یا مساوی این تعداد روز مونده بود، هشدار نشون بده



export const NewNavbar = (props) => {
  const { onRegClick, onLoginClick, onReqClick, onProfileClick } = props;
  const [active, setActive] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { user, isAuthenticated, logout } = useAuth();

  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setSubscription(null);
      return;
    }

    async function loadStatus() {
      const result = await getSubscriptionStatus();
      if (result.success) {
        setSubscription(result.data);
      }
    }
    loadStatus();
  }, [isAuthenticated]);

  const remainingDays = subscription?.active ? daysRemaining(subscription.endDate) : null;
  const showWarning = subscription?.active && remainingDays <= WARNING_THRESHOLD_DAYS;
  const showNoSubscription = isAuthenticated && subscription && !subscription.active;

  const handleConfirmLogout = () => {
    logout();
    setShowLogoutConfirm(false);
    setActive(false);
  };

  return (
    <div>
      <div className='w3-border w3-border-white w3-round-xxlarge ' style={{ padding: 10, display: "flex", flexDirection: "row-reverse", margin: 7 }}>
        <div className='w3-bar  w3-round-xxlarge' style={{ flex: 1, justifyContent: "flex-end", display: "flex", flexDirection: "row" }}>
          <div className='w3-bar-item w3-hide-small w3-hide-medium'>
            <ul className="w3-hide-medium w3-hide-small" style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>

              <button onClick={onReqClick} className='w3-margin-left w3-button w3-text-white'>
                <i className="material-icons w3-text-white w3-margin-left">file_upload</i>
                <a className=''>درخواست فایل</a>
              </button>

              {!isAuthenticated ? (
                <>
                  <button onClick={onLoginClick} className='w3-margin-left w3-button w3-text-white'>
                    <i className="material-icons w3-text-white w3-margin-left">login</i>
                    <a className=''>ورود</a>
                  </button>
                  <button onClick={onRegClick} className='w3-margin-left w3-button w3-text-white'>
                    <i className="material-icons w3-text-white w3-margin-left">how_to_reg</i>
                    <a className=''>ثبت نام</a>
                  </button>
                </>
              ) : (
                <div
                  className='w3-margin-left w3-round-xxlarge'
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "#1c2529",
                    padding: "4px 10px",
                    border: showWarning || showNoSubscription ? "1px solid #ff9800" : "1px solid #37474F",
                    position: "relative"
                  }}
                >
                  {/* آواتار با نشان هشدار */}
                  <div style={{ position: "relative" }} onClick={onProfileClick}>
                    <div
                      className="w3-circle"
                      style={{
                        width: 34,
                        height: 34,
                        backgroundColor: "#2980b9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        cursor: "pointer"
                      }}
                    >
                      <i className="material-icons w3-text-white" style={{ fontSize: 20 }}>person</i>
                    </div>

                    {(showWarning || showNoSubscription) && (
                      <div
                        style={{
                          position: "absolute",
                          top: -3,
                          left: -3,
                          width: 14,
                          height: 14,
                          borderRadius: "50%",
                          backgroundColor: "#ff9800",
                          border: "2px solid #1c2529",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <i className="material-icons" style={{ fontSize: 9, color: "#1c2529" }}>priority_high</i>
                      </div>
                    )}
                  </div>

                  {/* اطلاعات کاربر */}
                  <div
                    onClick={onProfileClick}
                    style={{ display: "flex", flexDirection: "column", margin: "0 8px", lineHeight: 1.3, cursor: "pointer" }}
                  >
                    <span className="w3-text-white" style={{ fontSize: 14, fontWeight: "bold" }}>
                      {user.account_name}
                    </span>
                    {showWarning ? (
                      <span style={{ fontSize: 11, color: "#ff9800", display: "flex", alignItems: "center" }}>
                        <i className="material-icons" style={{ fontSize: 12, marginLeft: 3 }}>schedule</i>
                        {remainingDays} روز تا پایان عضویت
                      </span>
                    ) : showNoSubscription ? (
                      <span style={{ fontSize: 11, color: "#ff9800", display: "flex", alignItems: "center" }}>
                        <i className="material-icons" style={{ fontSize: 12, marginLeft: 3 }}>warning</i>
                        بدون عضویت فعال
                      </span>
                    ) : (
                      <span className="w3-text-light-grey" style={{ fontSize: 12, display: "flex", alignItems: "center" }}>
                        <i className="material-icons" style={{ fontSize: 13, marginLeft: 3 }}>call</i>
                        {user.phone_number}
                      </span>
                    )}
                  </div>

                  <div style={{ width: 1, height: 26, backgroundColor: "#37474F", margin: "0 6px" }}></div>

                  <button
                    onClick={() => setShowLogoutConfirm(true)}
                    className="w3-button w3-round-xxlarge"
                    style={{
                      fontSize: 13,
                      color: "#ff0000",
                      backgroundColor: "transparent",
                      border: "1.5px solid #ff0000",
                      display: "flex",
                      alignItems: "center",
                      padding: "3px 10px"
                    }}
                  >
                    <i className="material-icons w3-margin-left" style={{ fontSize: 16, color: "#ff0000" }}>logout</i>
                    خروج
                  </button>
                </div>
              )}
            </ul>
          </div>
          <i onClick={() => setActive(true)} className="w3-hide-large material-icons w3-margin-top"
            style={{ fontSize: "60px", width: "40px", height: "40px", display: "flex", backgroundColor: "#263238", color: "#FFF" }}>menu</i>
        </div>

        <div className='w3-text-white  w3-margin-top' style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between" }}>
          <img src={logo} className='w3-margin-right w3-round-xlarge'></img>

          <p className='tittle w3-hide-small w3-hide-medium'
            style={{ fontWeight: "bolder", fontSize: 20, marginRight: 5, textAlign: "center" }}>
            دانلود بایوس بانک تخصصی فایل های بایوس برای حرفه ای ها
          </p>
        </div>
      </div>
      <p className='tittle w3-hide-large'
        style={{ fontWeight: "bolder", fontSize: 20, marginRight: 5, textAlign: "center" }}>
        دانلود بایوس بانک تخصصی فایل های بایوس برای حرفه ای ها
      </p>

      {/* منوی موبایل */}
      <div className={`${active ? "w3-show" : "w3-hide"} w3-hide w3-modal`} style={{ padding: 0 }}>
        <div className='w3-animate-right' style={{ backgroundColor: "white" }}>

          <div onClick={onReqClick} className='w3-ripple w3-button w3-paddig w3-border-bottom w3-border-color-light-gray' style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", width: "100%" }}>
            <i className="material-icons w3-text-black w3-margin-left">file_upload</i>درخواست فایل
          </div>

          {!isAuthenticated ? (
            <>
              <div onClick={onLoginClick} className='w3-ripple w3-button w3-paddig w3-border-bottom w3-border-color-light-gray' style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
                <i className="material-icons w3-text-black w3-margin-left">login</i>ورود
              </div>
              <div onClick={onRegClick} className='w3-ripple w3-button w3-paddig w3-border-bottom w3-border-color-light-gray' style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", width: "100%" }}>
                <i className="material-icons w3-text-black w3-margin-left">how_to_reg</i>ثبت نام
              </div>
            </>
          ) : (
            <>
              <div
                onClick={() => { onProfileClick(); setActive(false); }}
                style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", padding: "10px 12px", borderBottom: "1px solid #eee", position: "relative" }}
              >
                <div style={{ position: "relative" }}>
                  <div
                    className="w3-circle"
                    style={{ width: 36, height: 36, backgroundColor: "#2980b9", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
                  >
                    <i className="material-icons w3-text-white" style={{ fontSize: 20 }}>person</i>
                  </div>
                  {(showWarning || showNoSubscription) && (
                    <div
                      style={{
                        position: "absolute", top: -3, left: -3, width: 14, height: 14, borderRadius: "50%",
                        backgroundColor: "#ff9800", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center"
                      }}
                    >
                      <i className="material-icons" style={{ fontSize: 9, color: "white" }}>priority_high</i>
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", flexDirection: "column", margin: "0 10px", lineHeight: 1.4 }}>
                  <span style={{ fontSize: 14, fontWeight: "bold" }}>{user.account_name}</span>
                  {showWarning ? (
                    <span style={{ fontSize: 12, color: "#e65100", display: "flex", alignItems: "center" }}>
                      <i className="material-icons" style={{ fontSize: 13, marginLeft: 3 }}>schedule</i>
                      {remainingDays} روز تا پایان عضویت
                    </span>
                  ) : showNoSubscription ? (
                    <span style={{ fontSize: 12, color: "#e65100", display: "flex", alignItems: "center" }}>
                      <i className="material-icons" style={{ fontSize: 13, marginLeft: 3 }}>warning</i>
                      بدون عضویت فعال
                    </span>
                  ) : (
                    <span className="w3-text-grey" style={{ fontSize: 12, display: "flex", alignItems: "center" }}>
                      <i className="material-icons" style={{ fontSize: 13, marginLeft: 3 }}>call</i>
                      {user.phone_number}
                    </span>
                  )}
                </div>
              </div>
              <div onClick={() => setShowLogoutConfirm(true)} className='w3-ripple w3-button w3-paddig w3-border-bottom w3-border-color-light-gray' style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", width: "100%" }}>
                <i className="material-icons w3-text-black w3-margin-left" style={{ color: "#ff0000" }}>logout</i>خروج
              </div>
            </>
          )}

          <div className='w3-ripple w3-button w3-paddig w3-border-bottom w3-border-color-light-gray' style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "flex-start" }} onClick={() => setActive(false)}>
            <i className="material-icons w3-text-black w3-margin-left">exit_to_app</i>بازگشت
          </div>
        </div>
      </div>

      {/* مودال تایید خروج */}
      {showLogoutConfirm && (
        <div className="w3-modal" style={{ display: "flex", justifyContent: "center", alignItems: "center", zIndex: 999 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{
              backgroundColor: "#263238",
              borderTopLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              maxWidth: "320px",
              width: "90%",
              direction: "rtl",
              overflow: "hidden"
            }}
          >
            <div className="w3-container w3-padding" style={{ backgroundColor: "#ff000022", borderBottom: "2px solid #ff0000" }}>
              <span onClick={() => setShowLogoutConfirm(false)} className="w3-button w3-display-topright" style={{ color: "white" }}>
                &times;
              </span>
              <h4 className="w3-text-white" style={{ margin: 0, display: "flex", alignItems: "center" }}>
                <i className="material-icons w3-margin-left" style={{ color: "#ff0000" }}>logout</i>
                خروج از حساب کاربری
              </h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">آیا از خروج از برنامه مطمئن هستید؟</p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: "15px", display: "flex", gap: "10px" }}>
              <button
                onClick={handleConfirmLogout}
                className="w3-button"
                style={{ flex: 1, color: "#ffffff", backgroundColor: "#ff0000", border: "2px solid #ff0000", borderRadius: "10px" }}
              >
                بله، خارج شو
              </button>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="w3-button"
                style={{ flex: 1, color: "#15ff00", backgroundColor: "transparent", border: "2px solid #15ff00", borderRadius: "10px" }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
// export const Product = () => {
//   return (
//     <div>
//       <h1 className="w3-text-white w3-center" style={{ fontSize: '40px', marginTop: '10px' }}>
//         محصولات
//       </h1>

//       <div className="w3-row">
//         <div className="w3-col l4 m6 s12 w3-margin-bottom">
//           <div className="w3-margin w3-border w3-border-blue-gray w3-round-xxlarge">
//             <h1 className="w3-text-white w3-padding-16 w3-margin-right">انتخاب فایل</h1>
//           </div>
//         </div>

//         <div className="w3-col l4 m6 s12 w3-margin-bottom">
//           <div className="w3-margin w3-border w3-border-blue-grey w3-round-xxlarge">
//             <h1 className="w3-text-white w3-padding-16 w3-margin-right">برند</h1>
//           </div>
//         </div>

//         <div className="w3-col l4 m6 s12 w3-margin-bottom">
//           <div className="w3-margin w3-border w3-border-blue-grey w3-round-xxlarge">
//             <h1 className="w3-padding-16 w3-margin-right w3-text-white">نوع محصول</h1>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// اعتبارسنجی شماره موبایل
const validatephone_number=(phone_number)=> {
  const phone_numberPattern = /^09\d{9}$/;

  if (!phone_number) return 'شماره تماس الزامی است.';
  if (!/^\d+$/.test(phone_number)) return 'شماره تماس فقط باید شامل عدد باشد.';
  if (!phone_numberPattern.test(phone_number)) {
    return 'شماره تماس باید ۱۱ رقم باشد و با 09 شروع شود (مثال: 09123456789).';
  }
  return null;
}



// اعتبارسنجی رمز عبور
function validatePassword(password) {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>_\-+=]/.test(password);

  if (password.length < minLength) {
    return `رمز عبور باید حداقل ${minLength} کاراکتر باشد.`;
  }
  if (!hasUpperCase) {
    return 'رمز عبور باید حداقل شامل یک حرف بزرگ انگلیسی باشد.';
  }
  if (!hasLowerCase) {
    return 'رمز عبور باید حداقل شامل یک حرف کوچک انگلیسی باشد.';
  }
  if (!hasSpecialChar) {
    return 'رمز عبور باید حداقل شامل یک علامت خاص باشد (مثل !@#$%).';
  }

  return null;
}

// اعتبارسنجی شماره موبایل
function validatePhone(phone) {
  const phonePattern = /^09\d{9}$/;

  if (!phone) {
    return 'شماره تماس الزامی است.';
  }
  if (!/^\d+$/.test(phone)) {
    return 'شماره تماس فقط باید شامل عدد باشد.';
  }
  if (!phonePattern.test(phone)) {
    return 'شماره تماس باید ۱۱ رقم باشد و با 09 شروع شود (مثال: 09123456789).';
  }

  return null;
}

const inputBaseStyle = {
  border: '1px solid white',
  backgroundColor: 'transparent',
  borderRadius: '2px',
  borderTopLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  fontSize: '16px',
  height: '40px',
  width: '100%'
};

const FIELDS = [
  {
    name: 'account_name',
    label: 'نام کاربری:',
    type: 'text',
    placeholder: 'لطفا نام کاربری خود را وارد نمایید'
  },
  {
    name: 'password',
    label: 'رمز عبور:',
    type: 'password',
    placeholder: 'لطفا رمز عبور خود را وارد نمایید'
  },
  {
    name: 'phone',
    label: 'شماره تماس:',
    type: 'tel',
    placeholder: 'مثال: 09123456789',
    maxLength: 11,
    inputMode: 'numeric'
  }
];

export const RegisterForm = (props) => {
  const { visible, onHide } = props;

  const [formData, setFormData] = useState({
    account_name: '',
    password: '',
    phone: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [modal, setModal] = useState({
    show: false,
    type: 'success',
    message: ''
  });

  // مودال اطلاع‌رسانی محدودیت دانلود روزانه
  const [showLimitInfo, setShowLimitInfo] = useState(false);
  const [downloadLimit, setDownloadLimit] = useState(15);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const onlyNumbers = value.replace(/\D/g, '');
      setFormData({ ...formData, phone: onlyNumbers });
      setErrors({ ...errors, phone: validatePhone(onlyNumbers) || '' });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const closeMessageModal = async () => {
    const wasSuccess = modal.type === 'success';
    setModal({ show: false, type: 'success', message: '' });

    if (wasSuccess) {
      const result = await getDailyDownloadLimit();
      if (result.success) {
        setDownloadLimit(result.data.limit);
      }
      setShowLimitInfo(true);
    }
  };

  const closeLimitInfoModal = () => {
    setShowLimitInfo(false);
    onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phErr = validatePhone(formData.phone);
    if (phErr) {
      setErrors({ ...errors, phone: phErr });
      return;
    }

    const pwErr = validatePassword(formData.password);
    if (pwErr) {
      setErrors({ ...errors, password: pwErr });
      return;
    }

    setLoading(true);

    const result = await registerUser(
      formData.account_name,
      formData.password,
      formData.phone
    );

    if (result.success) {
      setModal({ show: true, type: 'success', message: result.data.message });
      setFormData({ account_name: '', password: '', phone: '' });
      setErrors({});
    } else {
      setModal({ show: true, type: 'error', message: result.message });
    }

    setLoading(false);
  };

  return visible ? (
    <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div
        className="w3-col l3 m8 s11 w3-border w3-border-white w3-card-4 w3-animate-zoom"
        style={{ overflow: 'visible', backgroundColor: '#263238', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}
      >
        <div className="w3-container" style={{ direction: 'rtl', overflow: 'visible' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', overflow: 'visible' }}>
            <img className="w3-circle" src={register} alt="register" style={{ marginTop: -60, zIndex: 5, width: 120 }} />
          </div>

          <form onSubmit={handleSubmit}>
            {FIELDS.map((field) => (
              <div key={field.name} style={{ marginBottom: '10px' }} className="w3-text-white w3-section">
                <label>{field.label}</label><br />
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  required
                  maxLength={field.maxLength}
                  inputMode={field.inputMode}
                  style={{
                    ...inputBaseStyle,
                    border: errors[field.name] ? '1px solid #ff0000' : inputBaseStyle.border
                  }}
                  className="w3-input"
                  placeholder={field.placeholder}
                />
                {errors[field.name] && (
                  <p className="w3-text-red" style={{ fontSize: '13px', marginTop: '5px' }}>
                    {errors[field.name]}
                  </p>
                )}
              </div>
            ))}

            <div className="w3-bar">
              <button
                type="submit"
                disabled={loading || !!errors.phone}
                className="w3-bar-item w3-right w3-button w3-block w3-section w3-padding-small w3-margin-left"
                style={{
                  fontSize: 16,
                  color: '#15ff00',
                  backgroundColor: 'transparent',
                  borderRadius: '10px',
                  border: '2px solid #2980b9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <span className="material-icons w3-text-green w3-padding">login</span>
                {loading ? 'در حال ارسال...' : ' ثبت نام'}
              </button>
              <button
                onClick={onHide}
                type="button"
                className="w3-bar-item w3-left w3-button w3-block w3-section w3-padding-small"
                style={{
                  fontSize: 16,
                  color: '#ff0000',
                  backgroundColor: 'transparent',
                  borderRadius: '10px',
                  border: '2px solid #2980b9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <span className="material-icons w3-padding" style={{ color: '#ff0000' }}>
                  transit_enterexit
                </span>
                خروج
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* مودال موفقیت/خطا */}
      {modal.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{
              backgroundColor: '#263238',
              borderTopLeftRadius: '20px',
              borderBottomRightRadius: '20px',
              maxWidth: '320px',
              width: '90%',
              direction: 'rtl',
              overflow: 'hidden'
            }}
          >
            <div
              className="w3-container w3-padding"
              style={{
                backgroundColor: modal.type === 'success' ? '#15ff0022' : '#ff000022',
                borderBottom: `2px solid ${modal.type === 'success' ? '#15ff00' : '#ff0000'}`
              }}
            >
              <span onClick={closeMessageModal} className="w3-button w3-display-topright" style={{ color: 'white' }}>
                &times;
              </span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>
                {modal.type === 'success' ? '✅ موفقیت' : '❌ خطا'}
              </h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">{modal.message}</p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
              <button
                onClick={closeMessageModal}
                className="w3-button w3-block"
                style={{
                  color: modal.type === 'success' ? '#15ff00' : '#ff0000',
                  backgroundColor: 'transparent',
                  border: `2px solid ${modal.type === 'success' ? '#15ff00' : '#ff0000'}`,
                  borderRadius: '10px'
                }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}

      {/* مودال اطلاع‌رسانی محدودیت دانلود روزانه */}
      {showLimitInfo && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{
              backgroundColor: '#263238',
              borderTopLeftRadius: '20px',
              borderBottomRightRadius: '20px',
              maxWidth: '340px',
              width: '90%',
              direction: 'rtl',
              overflow: 'hidden'
            }}
          >
            <div
              className="w3-container w3-padding"
              style={{ backgroundColor: '#4FC3F722', borderBottom: '2px solid #4FC3F7' }}
            >
              <h4 className="w3-text-white" style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                <i className="material-icons w3-margin-left" style={{ color: '#4FC3F7' }}>info</i>
                نکته مهم
              </h4>
            </div>

            <div className="w3-container w3-padding" style={{ textAlign: 'center' }}>
              <i className="material-icons" style={{ fontSize: 50, color: '#4FC3F7', marginBottom: 10 }}>
                cloud_download
              </i>
              <p className="w3-text-white">
                شما مجاز به دانلود حداکثر <b style={{ color: '#4FC3F7', fontSize: 18 }}>{downloadLimit}</b> فایل در روز هستید.
              </p>
              <p className="w3-text-white">
                کاربرگرامی در صورتی که فایل دانلود شده به صورت زیپ شده نبود به صورت دستی پسوند RAR. را اضافه و از فایل استفاده نمایید </p>
              <p className="w3-text-light-grey" style={{ fontSize: 13 }}>
                این محدودیت هر روز به‌صورت خودکار بازنشانی می‌شود.
              </p>
            </div>

            <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
              <button
                onClick={closeLimitInfoModal}
                className="w3-button w3-block"
                style={{ color: '#4FC3F7', backgroundColor: 'transparent', border: '2px solid #4FC3F7', borderRadius: '10px' }}
              >
                متوجه شدم
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : null;
};
export const Loginbutton = (props) => {
  const { lable, ...rest } = props;
  return (
    <div>
      <div className="w3-section">
        <label><b>{lable} </b></label>
        <input
          style={{
            border: '1px solid white',
            backgroundColor: 'transparent',
            borderRadius: '2px',
            borderTopLeftRadius: '10px',
            borderBottomRightRadius: '10px',
            fontSize: '16px',
            height: '40px',
            width: '100%',
            color:'white'
          }}
          className="w3-input"
          {...rest}
        />
      </div>
    </div>
  );
};
export const Login2 = (props) => {
  const { visible, onHide } = props;
  const { login } = useAuth();

  const [formData, setFormData] = useState({ account_name: '', password: '' });
  const [loading, setLoading] = useState(false);

  const [modal, setModal] = useState({
    show: false,
    type: 'error',
    message: ''
  });

  const arrLogin = [
    {
      id: 1,
      name: 'account_name',
      lable: ' نام کاربری ',
      placeholder: 'لطفا نام کاربری خود را وارد نمایید',
      type: 'text',
      value: formData.account_name
    },
    {
      id: 2,
      name: 'password',
      lable: ' رمز عبور ',
      placeholder: 'لطفا رمز عبور خود را وارد نمایید',
      type: 'password',
      value: formData.password
    }
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const closeMessageModal = () => {
    setModal({ show: false, type: 'error', message: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // اعتبارسنجی خالی نبودن فیلدها
    if (!formData.account_name.trim() || !formData.password.trim()) {
      setModal({
        show: true,
        type: 'error',
        message: 'لطفا نام کاربری و رمز عبور را وارد نمایید.'
      });
      return;
    }

    setLoading(true);

    const result = await loginUser(formData.account_name, formData.password);

    setLoading(false);

    if (result.success) {
      // ذخیره اطلاعات کاربر تو Context مشترک
      login(result.data.user, result.data.token);
      setFormData({ account_name: '', password: '' });
      onHide(); // بستن پنجره لاگین بعد از موفقیت
    } else {
      setModal({ show: true, type: 'error', message: result.message });
    }
  };

  return visible ? (
    <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div
        className="w3-border w3-border-white w3-card-4 w3-animate-zoom w3-col l3 m8 s11"
        style={{ overflow: 'visible', backgroundColor: '#263238', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}
      >
        <div className="w3-container" style={{ direction: 'rtl', overflow: 'visible' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', overflow: 'visible' }}>
            <img className="w3-circle" src={loginImg} alt="login" style={{ marginTop: -60, zIndex: 5, width: 120 }} />
          </div>

          <form onSubmit={handleSubmit}>
            <div className="w3-text-white w3-section">
              {arrLogin.map((field) => (
                <Loginbutton
                  key={field.id}
                  lable={field.lable}
                  name={field.name}
                  type={field.type}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={handleChange}
                  required
                />
              ))}

              <div className="w3-bar">
                <button
                  type="submit"
                  disabled={loading}
                  className="w3-bar-item w3-right w3-button w3-block w3-section w3-padding-small w3-margin-left"
                  style={{
                    fontSize: 16,
                    color: ' #15ff00',
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    border: '2px solid #2980b9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <span className="material-icons w3-text-green w3-padding">login</span>
                  {loading ? 'در حال ورود...' : 'ورود'}
                </button>
                <button
                  onClick={onHide}
                  type="button"
                  className="w3-bar-item w3-left w3-button w3-block w3-section w3-padding-small"
                  style={{
                    fontSize: 16,
                    color: ' #ff0000',
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    border: '2px solid #2980b9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <span className="material-icons w3-padding" style={{ color: ' #ff0000' }}>
                    transit_enterexit
                  </span>
                  خروج
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* مودال نمایش خطا */}
      {modal.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div
            className="w3-card-4 w3-animate-zoom"
            style={{
              backgroundColor: '#263238',
              borderTopLeftRadius: '20px',
              borderBottomRightRadius: '20px',
              maxWidth: '320px',
              width: '90%',
              direction: 'rtl',
              overflow: 'hidden'
            }}
          >
            <div
              className="w3-container w3-padding"
              style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}
            >
              <span onClick={closeMessageModal} className="w3-button w3-display-topright" style={{ color: 'white' }}>
                &times;
              </span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>❌ خطا</h4>
            </div>

            <div className="w3-container w3-padding">
              <p className="w3-text-white">{modal.message}</p>
            </div>

            <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
              <button
                onClick={closeMessageModal}
                className="w3-button w3-block"
                style={{
                  color: '#ff0000',
                  backgroundColor: 'transparent',
                  border: '2px solid #ff0000',
                  borderRadius: '10px'
                }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : null;
};
// نگاشت اسم برند به دامنه‌ی رسمی شرکت، برای گرفتن لوگوی واقعی
// اگر برند مورد نظرت اینجا نبود، کافیه یک خط با دامنه‌ی درستش اضافه کنی
const selectStyle = {
  border: '1px solid white',
  backgroundColor: 'transparent',
  borderRadius: '2px',
  borderTopLeftRadius: '10px',
  borderBottomRightRadius: '10px',
  fontSize: '16px',
  height: '40px',
  width: '100%',
  color: 'white',
  padding: '0 10px'
};

// لیبل کوچک همراه با آیکون برای هر بخش
const ProductLayoutStyles = () => (
  <style>{`
    .product-field-label {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      gap: 6px !important;
      margin-bottom: 8px !important;
    }
    .product-field-label .material-icons {
      flex-shrink: 0 !important;
    }
    .product-grid {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr) !important;
      gap: 16px !important;
    }
    @media (max-width: 700px) {
      .product-grid {
        grid-template-columns: 1fr !important;
      }
    }
  `}</style>
);

const FieldLabel = ({ icon, text }) => (
  <div className="w3-text-white product-field-label">
    <span
      className="material-icons"
      style={{ color: '#4fc3f7', fontSize: '20px', flexShrink: 0, lineHeight: 1 }}
    >
      {icon}
    </span>
    <span style={{ fontSize: '17px', whiteSpace: 'nowrap' }}>{text}</span>
  </div>
);

export const SearchableSelect = ({
  options,
  value,
  onChange,
  placeholder,
  disabled,
  loading,
  contentDir = 'rtl',
  capitalizeOptions = false,
  remote = false,      // ⬅️ جدید: اگه true باشه، فیلتر سمت کلاینت خاموش می‌شه
  onSearch,            // ⬅️ جدید: تابعی که با هر تغییر جستجو صدا زده می‌شه
  hasMore = false      // ⬅️ جدید: نشون می‌ده نتایج بیشتری هم هست
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);

  const selectedOption = options.find((o) => String(o.id) === String(value));

  const filteredOptions = remote
    ? options
    : options.filter((o) => o.name.toLowerCase().includes(search.toLowerCase()));

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // با هر تغییر تایپ، بعد از یه مکث کوتاه، دوباره از سرور می‌خواد (فقط تو حالت remote)
  useEffect(() => {
    if (!remote || !onSearch) return;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onSearch(search);
    }, 350);
    return () => clearTimeout(debounceRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, remote]);

  const handleSelect = (option) => {
    onChange(option.id);
    setOpen(false);
    setSearch('');
  };

  const handleToggle = () => {
    if (disabled) return;
    const willOpen = !open;
    setOpen(willOpen);
    // موقع باز شدن، اگه remote هست، اولین ۱۰۰ نتیجه (بدون جستجو) رو بگیر
    if (willOpen && remote && onSearch) {
      onSearch(search);
    }
  };

  const textTransform = capitalizeOptions ? 'capitalize' : 'none';

  return (
    <div ref={wrapperRef} style={{ position: 'relative', direction: 'rtl', width: '100%' }}>
      <div
        onClick={handleToggle}
        className="w3-input w3-border"
        style={{
          border: '1px solid white',
          backgroundColor: 'transparent',
          borderRadius: '2px',
          borderTopLeftRadius: '10px',
          borderBottomRightRadius: '10px',
          fontSize: '16px',
          height: '40px',
          width: '100%',
          color: 'white',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          padding: '0 10px',
          direction: contentDir
        }}
      >
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            direction: contentDir,
            textAlign: contentDir === 'rtl' ? 'right' : 'left',
            textTransform,
            flex: 1,
            minWidth: 0
          }}
        >
          {loading && !open ? 'در حال بارگذاری...' : (selectedOption ? selectedOption.name : placeholder)}
        </span>
        <i className="material-icons" style={{ fontSize: 20, color: '#ccc', flexShrink: 0, marginRight: 4 }}>
          {open ? 'arrow_drop_up' : 'arrow_drop_down'}
        </i>
      </div>

      {open && !disabled && (
        <div
          className="w3-card-4 w3-animate-opacity"
          style={{
            position: 'absolute',
            top: '105%',
            right: 0,
            left: 0,
            backgroundColor: '#1c2529',
            border: '1px solid #37474F',
            borderRadius: '10px',
            zIndex: 50,
            maxHeight: '260px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
          <div style={{ padding: '8px', borderBottom: '1px solid #37474F' }}>
            <input
              autoFocus
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="جستجو کنید..."
              dir={contentDir}
              style={{
                width: '100%',
                padding: '6px 10px',
                borderRadius: '8px',
                border: '1px solid #455A64',
                backgroundColor: '#263238',
                color: 'white',
                outline: 'none',
                fontSize: '14px',
                textAlign: contentDir === 'rtl' ? 'right' : 'left'
              }}
            />
          </div>

          <div style={{ overflowY: 'auto', maxHeight: '210px' }}>
            {loading ? (
              <div className="w3-padding w3-text-grey" style={{ fontSize: 14, textAlign: 'center' }}>
                در حال جستجو...
              </div>
            ) : filteredOptions.length === 0 ? (
              <div className="w3-padding w3-text-grey" style={{ fontSize: 14, textAlign: 'center' }}>
                نتیجه‌ای یافت نشد
              </div>
            ) : (
              <>
                {filteredOptions.map((option) => (
                  <div
                    key={option.id}
                    onClick={() => handleSelect(option)}
                    className="w3-hover-blue-grey"
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      color: 'white',
                      fontSize: '14px',
                      backgroundColor: String(option.id) === String(value) ? '#2980b9' : 'transparent',
                      borderBottom: '1px solid #263238',
                      direction: contentDir,
                      textAlign: contentDir === 'rtl' ? 'right' : 'left',
                      textTransform
                    }}
                  >
                    {option.name}
                  </div>
                ))}
                {remote && hasMore && (
                  <div style={{ padding: '8px 12px', fontSize: 12, textAlign: 'center', color: '#ffb74d', borderTop: '1px solid #263238' }}>
                    نتایج بیشتری وجود دارد؛ برای دقیق‌تر شدن جستجو، حروف بیشتری تایپ کنید
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};


export const Product = () => {
  const [productTypes, setProductTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const [files, setFiles] = useState([]);

  const [selectedType, setSelectedType] = useState('');
  const [selectedBrand, setSelectedBrand] = useState('');
  const [selectedFile, setSelectedFile] = useState('');

  const [loadingBrands, setLoadingBrands] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [purchasingFile, setPurchasingFile] = useState(false);

  const [modal, setModal] = useState({ show: false, type: 'error', message: '' });
  const [filesHasMore, setFilesHasMore] = useState(false);
  useEffect(() => {
    async function loadTypes() {
      const result = await getProductTypes();
      if (result.success) {
        setProductTypes(result.data.productTypes);
      } else {
        setModal({ show: true, type: 'error', message: result.message });
      }
    }
    loadTypes();
  }, []);

  const handleTypeChange = async (typeId) => {
    setSelectedType(typeId);
    setSelectedBrand('');
    setSelectedFile('');
    setBrands([]);
    setFiles([]);

    if (!typeId) return;

    setLoadingBrands(true);
    const result = await getBrands(typeId);
    setLoadingBrands(false);

    if (result.success) {
      setBrands(result.data.brands);
    } else {
      setModal({ show: true, type: 'error', message: result.message });
    }
  };

  const handleBrandChange = async (brandId) => {
    setSelectedBrand(brandId);
    setSelectedFile('');
    setFiles([]);
    setFilesHasMore(false);
    
    if (!brandId) return;

    setLoadingFiles(true);
    const result = await getFiles(brandId);
    setLoadingFiles(false);

    if (result.success) {
      setFiles(result.data.files);
    } else {
      setModal({ show: true, type: 'error', message: result.message });
    }
  };


  const handleFileSearch = async (searchTerm) => {
  if (!selectedBrand) return;

  setLoadingFiles(true);
  const result = await getFiles(selectedBrand, searchTerm);
  setLoadingFiles(false);

  if (result.success) {
    setFiles(result.data.files);
    setFilesHasMore(result.data.truncated);
  } else {
    setModal({ show: true, type: 'error', message: result.message });
  }
};

  const handleFileChange = (fileId) => {
    setSelectedFile(fileId);
  };



const handleDownload = async () => {
  if (!selectedFile) {
    setModal({ show: true, type: 'error', message: 'لطفا یک فایل را انتخاب کنید.' });
    return;
  }

  const fileObj = files.find((f) => String(f.id) === String(selectedFile));

  setDownloading(true);
  // ⬇️ اینجا از file_path استفاده می‌کنیم، نه file_name، چون همیشه پسوند درست داره
  const result = await downloadFile(selectedFile, fileObj?.file_path || fileObj?.file_name);
  setDownloading(false);

  if (!result.success) {
    setModal({
      show: true,
      type: 'error',
      message: result.message,
      requiresPurchase: result.requiresPurchase,
      singleFilePrice: result.singleFilePrice
    });
  }
};

const handleBuySingleFile = async () => {
  setPurchasingFile(true);
  const result = await purchaseSingleFile(selectedFile);
  setPurchasingFile(false);

  if (result.success) {
    window.location.href = result.paymentUrl;
  } else {
    setModal({ show: true, type: 'error', message: result.message });
  }
};

  const closeModal = () => setModal({ show: false, type: 'error', message: '' });

  // آماده‌سازی لیست‌ها با فرمت { id, name, logo? } برای SearchableSelect
  const typeOptions = productTypes.map((t) => ({ id: t.id, name: t.name }));
  const brandOptions = brands.map((b) => ({ id: b.id, name: b.name }));
  const fileOptions = files.map((f) => ({ id: f.id, name: f.file_name }));

  return (
    <div style={{ direction: 'rtl' }}>
      <ProductLayoutStyles />
      <h1 className="w3-text-white w3-center" style={{ fontSize: '40px', marginTop: '10px' }}>
        محصولات
      </h1>

      <div
        className="product-grid"
        style={{
          direction: 'rtl'
        }}
      >
        {/* نوع محصول */}
        <div
          style={{ minWidth: 0 }}
          className="w3-border w3-border-blue-gray w3-round-xxlarge"
        >
          <div className="w3-container" style={{ padding: '16px' }}>
            <FieldLabel icon="category" text="نوع محصول" />
            <SearchableSelect
              options={typeOptions}
              value={selectedType}
              onChange={handleTypeChange}
              placeholder="انتخاب کنید..."
              contentDir="rtl"
            />
          </div>
        </div>

        {/* برند */}
        <div
          style={{ minWidth: 0 }}
          className="w3-border w3-border-blue-grey w3-round-xxlarge"
        >
          <div className="w3-container" style={{ padding: '16px' }}>
            <FieldLabel icon="sell" text="برند" />
            <SearchableSelect
              options={brandOptions}
              value={selectedBrand}
              onChange={handleBrandChange}
              placeholder="انتخاب کنید..."
              disabled={!selectedType}
              loading={loadingBrands}
              contentDir="ltr"
              capitalizeOptions
            />
          </div>
        </div>

        {/* انتخاب فایل */}
        <div
          style={{ minWidth: 0 }}
          className="w3-border w3-border-blue-grey w3-round-xxlarge"
        >
          <div className="w3-container" style={{ padding: '16px' }}>
            <FieldLabel icon="insert_drive_file" text="انتخاب فایل" />
            <SearchableSelect
              options={fileOptions}
              value={selectedFile}
              onChange={handleFileChange}
              placeholder="انتخاب کنید..."
              disabled={!selectedBrand}
              loading={loadingFiles}
              contentDir="ltr"
              remote={true}                 // ⬅️ اضافه شد
              onSearch={handleFileSearch}   // ⬅️ اضافه شد
              hasMore={filesHasMore}        // ⬅️ اضافه شد
            />
          </div>
        </div>
      </div>

      {/* دکمه دانلود */}
      <div className="w3-center w3-margin-top w3-margin-bottom">
        <button
          onClick={handleDownload}
          disabled={!selectedFile || downloading}
          className="w3-button w3-round-xxlarge"
          style={{
            fontSize: 16,
            color: '#15ff00',
            backgroundColor: 'transparent',
            border: '2px solid #2980b9',
            padding: '10px 30px',
            display: 'inline-flex',
            alignItems: 'center'
          }}
        >
          <span className="material-icons w3-margin-left">download</span>
          {downloading ? 'در حال دانلود...' : 'دانلود فایل'}
        </button>
      </div>

      {/* مودال خطا */}
{modal.show && (
  <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
    <div
      className="w3-card-4 w3-animate-zoom"
      style={{
        backgroundColor: '#263238',
        borderTopLeftRadius: '20px',
        borderBottomRightRadius: '20px',
        maxWidth: '340px',
        width: '90%',
        direction: 'rtl',
        overflow: 'hidden'
      }}
    >
      <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
        <span onClick={closeModal} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
        <h4 className="w3-text-white" style={{ margin: 0 }}>❌ خطا</h4>
      </div>
      <div className="w3-container w3-padding">
        <p className="w3-text-white">{modal.message}</p>
      </div>
      <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
        {modal.requiresPurchase && (
          <button
            onClick={handleBuySingleFile}
            disabled={purchasingFile}
            className="w3-button w3-block w3-margin-bottom"
            style={{ color: '#15ff00', backgroundColor: 'transparent', border: '2px solid #15ff00', borderRadius: '10px',fontSize:'12px' }}
          >
            {purchasingFile
              ? 'در حال انتقال به درگاه...'
              : `خرید همین فایل به قیمت ${new Intl.NumberFormat('fa-IR').format(modal.singleFilePrice)} تومان`}
          </button>
        )}
        <button
          onClick={closeModal}
          className="w3-button w3-block"
          style={{ color: '#ff0000', backgroundColor: 'transparent', border: '2px solid #ff0000', borderRadius: '10px' }}
        >
          باشه
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

function daysRemaining(endDate) {
  const end = new Date(endDate);
  const now = new Date();
  const diffMs = end - now;
  const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  return days > 0 ? days : 0;
}

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('fa-IR');
}

export const Profile = ({ visible, onHide }) => {
  const { user, isAuthenticated } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!visible || !isAuthenticated) return;

    async function loadSubscription() {
      setLoading(true);
      const result = await getSubscriptionStatus();
      if (result.success) {
        setSubscription(result.data);
      }
      setLoading(false);
    }

    loadSubscription();
  }, [visible, isAuthenticated]);

  if (!visible) return null;

  return (
    <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div
        className="w3-border w3-border-white w3-card-4 w3-animate-zoom w3-col l3 m8 s11"
        style={{
          backgroundColor: '#263238',
          borderTopLeftRadius: '30px',
          borderBottomRightRadius: '30px',
          overflow: 'hidden'
        }}
      >
        <div className="w3-container" style={{ direction: 'rtl' }}>
          {/* هدر */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px 0'
            }}
          >
            <div
              className="w3-circle"
              style={{
                width: 80,
                height: 80,
                backgroundColor: '#2980b9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="material-icons w3-text-white" style={{ fontSize: 44 }}>person</i>
            </div>
          </div>

          {/* اطلاعات کاربر */}
          <div className="w3-section w3-text-white">
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
              <i className="material-icons w3-margin-left" style={{ color: '#2980b9' }}>badge</i>
              <span style={{ fontSize: 16 }}>{user?.account_name}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
              <i className="material-icons w3-margin-left" style={{ color: '#2980b9' }}>call</i>
              <span style={{ fontSize: 16 }}>{user?.phone_number}</span>
            </div>
          </div>

          <hr style={{ borderColor: '#37474F' }} />

          {/* وضعیت عضویت */}
          <div className="w3-section" style={{ marginBottom: 15 }}>
            <h4 className="w3-text-white" style={{ display: 'flex', alignItems: 'center' }}>
              <i className="material-icons w3-margin-left" style={{ color: '#4FC3F7' }}>workspace_premium</i>
              وضعیت عضویت
            </h4>

            {loading ? (
              <p className="w3-text-grey">در حال بررسی...</p>
            ) : subscription?.active ? (
              <div
                className="w3-round-large"
                style={{
                  backgroundColor: '#15ff0015',
                  border: '1px solid #15ff00',
                  padding: '12px',
                  marginTop: 8
                }}
              >
                <p className="w3-text-white" style={{ margin: '4px 0' }}>
                  <b>پلن فعال:</b> {subscription.planTitle}
                </p>
                <p className="w3-text-white" style={{ margin: '4px 0' }}>
                  <b>تاریخ انقضا:</b> {formatDate(subscription.endDate)}
                </p>
                <p style={{ margin: '4px 0', color: '#15ff00' }}>
                  <b>{daysRemaining(subscription.endDate)} روز</b> تا پایان عضویت باقی مانده
                </p>
              </div>
            ) : (
              <div
                className="w3-round-large"
                style={{
                  backgroundColor: '#ff000015',
                  border: '1px solid #ff0000',
                  padding: '12px',
                  marginTop: 8
                }}
              >
                <p className="w3-text-white" style={{ margin: 0 }}>
                  شما در حال حاضر عضویت فعالی ندارید. برای دانلود فایل‌ها، یکی از پلن‌های عضویت را خریداری کنید.
                </p>
              </div>
            )}
          </div>

          {/* دکمه بستن */}
          <div className="w3-bar w3-margin-bottom">
            <button
              onClick={onHide}
              className="w3-bar-item w3-button w3-block w3-section w3-padding-small"
              style={{
                fontSize: 16,
                color: '#ff0000',
                backgroundColor: 'transparent',
                borderRadius: '10px',
                border: '2px solid #2980b9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <span className="material-icons w3-padding" style={{ color: '#ff0000' }}>
                close
              </span>
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};